(function () {
  var MOBILE_BREAKPOINT = 768;

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function initPdpTabs(section) {
    var items = section.querySelectorAll('.pdp-tab__item');
    var panels = section.querySelectorAll('.pdp-tab__panel');
    var headings = section.querySelectorAll('.pdp-tab__heading');


    items.forEach(function (item) {
      item.querySelector('a').addEventListener('click', function (e) {
        e.preventDefault();
        if (isMobile()) return; 

        var target = item.getAttribute('data-target');

        items.forEach(el => el.classList.remove('pdp-tab__item--active'));
        panels.forEach(el => el.classList.remove('pdp-tab__panel--active'));

        item.classList.add('pdp-tab__item--active');
        var activePanel = section.querySelector('#' + target);
        if (activePanel) activePanel.classList.add('pdp-tab__panel--active');
      });
    });

    headings.forEach(function (heading) {
      heading.addEventListener('click', function () {
        if (!isMobile()) return; 

        var panel = heading.closest('.pdp-tab__panel');
        var body = panel.querySelector('.pdp-tab__body');
        var isOpen = panel.classList.contains('pdp-tab__panel--open');


        panels.forEach(function (p) {
          p.classList.remove('pdp-tab__panel--open');
          var b = p.querySelector('.pdp-tab__body');
          b.style.maxHeight = null;
          p.querySelector('.pdp-tab__icon').textContent = '+';
        });

        if (!isOpen) {
          panel.classList.add('pdp-tab__panel--open');
          body.style.maxHeight = body.scrollHeight + 'px';
          panel.querySelector('.pdp-tab__icon').textContent = '−';
        }
      });
    });
  }

  document.querySelectorAll('.pdp-tab').forEach(initPdpTabs);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.pdp-tab');
      if (section) initPdpTabs(section);
    });
  }
})();